import { observable, action } from "mobx";
import ApiCaller from "../utils/api-caller";
import moment from "moment";

class GuestLoginLogStore {
  // Properties

  // Modal Create/Update Properties

  @observable showGuestLoginLogModal = false;
  @observable guestLoginLogTitle = "";
  @observable tabNameActiveKey = "1";
  @observable tabDescriptionActiveKey = "1";
  @observable guestLoginLog = null;
  @observable guestLoginLogs = [];
  @observable totalData = 0;
  // Helper Properties
  @observable guestLoginLogListLoading = false;
  @observable guestLoginLogModalLoading = false;
  // Initialization
  @action initGuestLoginLog(
    fromDate,
    endDate,
    currentPage,
    pageSize,
    roomNumber,
    guestName
  ) {
    this.guestLoginLogListLoading = true;
    let fromDateTime = moment(fromDate).format("DD/MM/YYYY");
    let toDateTime = moment(endDate).format("DD/MM/YYYY");
    var request = {
      fromDate: fromDateTime,
      toDate: toDateTime,
      currentPage: currentPage,
      pageSize: pageSize,
      roomNumber: roomNumber,
      guestName: guestName,
    };
    return ApiCaller.GuestLoginLogs.filter(request).then((resp) => {
      if (resp.isSuccess) {
        resp.model.map((m) => {
          return (m.createdDate = moment(m.createdDate).format(
            "DD/MM/yyyy HH:mm:ss"
          ));
        });
        this.guestLoginLogs = resp.model;
        this.totalData = resp.totalData;
        this.guestLoginLogListLoading = false;
      } else {
        this.guestLoginLogs = [];
        this.totalData = 0;
        this.guestLoginLogListLoading = false;
      }
    });
  }
  @action initUpdateGuestLoginLog(id) {
    this.guestLoginLogModalLoading = true;
    this.guestLoginLogTitle = "Guest Login Log Detail";
    this.showGuestLoginLogModal = true;
    this.guestLoginLog = this.guestLoginLogs.find((fi) => fi.id === id);
    this.guestLoginLogModalLoading = false;
  }
  // SET Properties
  @action setShowGuestLoginLogModal(value) {
    this.showGuestLoginLogModal = value;
    if (!value) {
      this.tabNameActiveKey = "1";
      this.tabDescriptionActiveKey = "1";
    }
  }

  @action setshowGuestLoginLogModal(value) {
    this.showGuestLoginLogModal = value;
  }
}

export default new GuestLoginLogStore();
